import {
  Backdrop,
  Box,
  CircularProgress,
  Divider,
  Drawer,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { CustomTypography } from "../formsComponents";
import { IRightPanelProps } from "./interfaces/IRightPanelProps";
import { Close } from "@mui/icons-material";

export const RightPanel: React.FC<IRightPanelProps> = (props) => {
  const {
    open,
    heading,
    customHeading,
    isWrappedWithForm = false,
    onFormSubmit,
    showBackdrop,
    subHeading,
    actionButtons,
    width,
    onClose,
    hideScroll = false,
    hideScrollbar = false,
    drawerProps,
    paperSx,
    hideCrossTopButton = false,
    sx,
    ModalProps,
    topRightButtons,
    disablePadding = false
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const content = () => {
    return (
      <Box
        display="flex"
        flexDirection={"column"}
        height={"100vh"}
        onClick={(e) => e.stopPropagation()}
      >
        {heading && (
          <Box
            sx={{
              flexShrink: 0,
              minHeight: "8vh",
              padding: "8px 20px",
              backgroundColor: theme.palette.primary.main,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              width="100%"
            >
              <Typography variant="h2" fontWeight={"bold"} color="#fff" sx={{ fontSize: { xs: "1rem", md: "1.25rem" } }}>
                {heading}
              </Typography>
              {!hideCrossTopButton && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  {topRightButtons}
                  <Box
                    onClick={onClose}
                    sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                  >
                    <Close sx={{ color: "#fff" }} />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        )}
        {subHeading && (
          <Box sx={{ px: 2.5, pb: 0.5, backgroundColor: theme.palette.primary.main, flexShrink: 0 }}>
            {typeof subHeading === "string" ? <CustomTypography variant="body2" sx={{ color: "#fff" }}>{subHeading}</CustomTypography> : subHeading}
          </Box>
        )}
        {customHeading && (
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{
              padding: "15px 10px",
              flexShrink: 0,
            }}
          >
            {customHeading}
          </Box>
        )}

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: hideScroll ? "hidden" : "auto",
            ...(!disablePadding && {
              padding: "0px 20px",
            }),
            ...(hideScrollbar && {
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }),
            ...sx
          }}
        >
          {props.children}
        </Box>
        {actionButtons && (
          <>
            <Divider />
            <Box sx={{
              flexShrink: 0,
              minHeight: "8vh",
              display: "flex",
              alignItems: "center",
              padding: "0 20px",
              mb: isMobile ? 6 : 0,
            }}>
              {actionButtons()}
            </Box>
          </>
        )}
      </Box>
    );
  };
  const wrappedWithForm = () => {
    if (isWrappedWithForm && onFormSubmit) {
      return (
        <form onSubmit={(e) => { e.preventDefault(); onFormSubmit(); }} style={{ height: "100%" }}>
          {content()}
        </form>
      );
    }
    return content();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={drawerProps}
      ModalProps={ModalProps}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            md: width || "80%",
            lg: width || "35%",
          },
          padding: 0,
          height: "100vh",
          overflowY: "hidden",
          ...paperSx,
        },
      }}
      onClose={onClose}
    >
      {wrappedWithForm()}

      {showBackdrop && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showBackdrop}
        >
          <CircularProgress size={100} />
        </Backdrop>
      )}
    </Drawer>
  );
};
